import React from 'react';
const GroupMembers: React.FC<{
  groupId?: string;
}> = ({
  groupId
}) => {
  return <div className="bg-white rounded-lg border border-gray-200 p-4" data-id="element-1226">
      <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-1227">Membri</h2>
      <p className="text-gray-500" data-id="element-1228">Sezione in sviluppo</p>
    </div>;
};
export default GroupMembers;